<template>
  <div class="home">
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>

    <md-tabs
      class="tabs"
      v-if="orders.length"
      @md-changed="tabChanged"
      :md-active-tab="tab"
      :style="{ height: 'auto' }"
      md-elevation="0"
    >
      <template slot="md-tab" slot-scope="{ tab }">
        <div>{{ tab.label }}</div>
        <md-badge
          v-if="tab.data.badge"
          :md-content="tab.data.badge"
          style="top: 0; right: 0px"
        ></md-badge>
      </template>

      <md-tab
        class="custom-tab-content"
        id="all"
        md-label="Все"
        key="0"
        :md-template-data="{ badge: countProducts(allProducts) }"
      >
        <div class="md-layout" v-if="tab === 'all'">
          <div
            class="md-layout-item md-xlarge-size-10 md-large-size-20 md-medium-size-33 md-small-size-25 md-xsmall-size-50"
            v-for="product in allProducts"
            :key="product.uniqueId"
          >
            <ShowProduct :product="product"></ShowProduct>
          </div>
        </div>
      </md-tab>

      <md-tab
        id="assembled"
        md-label="Собраны"
        key="1"
        :md-template-data="{ badge: countAssembledProducts(assembledProducts) }"
      >
        <div class="md-layout" v-if="tab === 'assembled'">
          <div
            class="md-layout-item md-xlarge-size-10 md-large-size-20 md-medium-size-33 md-small-size-25 md-xsmall-size-50"
            v-for="product in assembledProducts"
            :key="product.uniqueId"
          >
            <ShowProduct :product="product"></ShowProduct>
          </div>
        </div>
      </md-tab>

      <md-tab
        v-if="orders.length > 1"
        v-for="order in orders"
        :key="order.order_id"
        :id="order.order_id"
        :md-label="order.order_number"
        :md-template-data="{ badge: countProductsIn(order) }"
      >
        <div class="md-layout" v-if="tab === order.order_id">
          <div
            class="md-layout-item md-xlarge-size-10 md-large-size-20 md-medium-size-33 md-small-size-25 md-xsmall-size-50"
            v-for="product in getOrderProducts(order)"
            :key="product.uniqueId"
            v-if="product.quantity !== product.assembled"
          >
            <ShowProduct :product="product"></ShowProduct>
          </div>
        </div>
      </md-tab>
    </md-tabs>

    <md-empty-state
      v-if="!orders.length"
      md-icon="whatshot"
      md-label="Заказы еще не загружены"
      md-description="Заказы еще не загружены. Возможно вы не выбрали их в 1С"
    ></md-empty-state>
  </div>
</template>

<script>
  import ShowProduct from "../components/ShowProduct";

  export default {
    name: "Home",
    components: { ShowProduct },
    data: () => ({
      loading: false,
      m: false,
    }),
    computed: {
      allProducts() {
        let products = [];

        this.orders.forEach((order) => {
          order.carts.forEach((cart) => {
            cart.products.forEach((product) => {
              if (product.quantity !== product.assembled) {
                products.push(product);
              }
            });
          });
        });

        products = products.sort((a, b) => a.sort - b.sort);

        return products;
      },
      assembledProducts() {
        let products = [];

        this.orders.forEach((order) => {
          order.carts.forEach((cart) => {
            cart.products.forEach((product) => {
              if (product.quantity === product.assembled) {
                products.push(product);
              }
            });
          });
        });

        return products;
      },
      orders() {
        return this.$store.state.orders.items;
      },
      tab() {
        return this.$store.state.tab.item;
      },
      drawler() {
        return this.$store.state.drawler.item;
      },
    },
    watch: {
      products() {
        this.setScroll();
      },
      allProducts() {
        if (!this.allProducts.length && this.tab === "all") {
          this.tabChanged("assembled");
        }
      },
      assembledProducts() {
        if (!this.assembledProducts.length && this.tab === "assembled") {
          this.tabChanged("all");
        }
      },
    },
    beforeDestroy() {
      this.$store.commit("scroll/setScroll", false);
    },
    created: function () {
      this.setScroll();
    },
    methods: {
      getOrderProducts(order) {
        let products = [];

        order.carts.forEach((cart) => {
          cart.products.forEach((product) => {
            products.push(product);
          });
        });

        return products;
      },
      setScroll() {
        if (
          (this.products.length > 5 && this.drawler === "land") ||
          (this.products.length > 9 && this.drawler === "port")
        ) {
          this.$store.commit("scroll/setScroll", true);
        }
      },
      countProductsIn(order) {
        let productsCount = 0;
        order.carts.forEach((cart) => {
          cart.products.forEach((product) => {
            if (product.quantity !== product.assembled) {
              productsCount = Math.abs(
                productsCount + (product.quantity - product.assembled)
              );
            }
          });
        });

        return productsCount;
      },
      countProducts(products) {
        let productsCount = 0;

        products.forEach((product) => {
          if (product.quantity !== product.assembled) {
            productsCount = Math.abs(
              productsCount + (product.quantity - product.assembled)
            );
          }
        });

        return productsCount;
      },
      countAssembledProducts(products) {
        let productsCount = 0;

        products.forEach((product) => {
          productsCount = Math.abs(productsCount + product.assembled);
        });

        return productsCount;
      },
      tabChanged(activeTab) {
        this.$store.commit("tab/setTab", activeTab);
      },
      clearError: function () {
        this.error = {
          code: null,
          message: null,
        };
      },
    },
  };
</script>

<style lang="scss">
  // .md-content.md-tabs-content.md-theme-default {
  //     height: auto !important;
  // }
  .tabs > .md-tabs-navigation {
    flex-wrap: nowrap;
    overflow: auto;
  }
</style>
